import Component, { mixins } from "vue-class-component";

import { PageTitle } from "@/mixins/PageTitle";
import { LogService } from "@/services";
import { getStoreModule, SessionModule } from "@/store";
import { Metadata, MetadataKeys, User, UserType, VignetteHelpers } from "@/types";

@Component
export class ViewAnalytics extends mixins(PageTitle) {
  private metadata!: Metadata;

  created(): void {
    const sessionInfo: User = getStoreModule(SessionModule, this.$store).getUser;

    this.metadata = {
      // User metadata
      [MetadataKeys.LOGIN_STATUS]: sessionInfo != null ? "Logged In" : "Anonymous",
      [MetadataKeys.AUTHENTICATION_TYPE]:
        sessionInfo != null
          ? sessionInfo.userType === UserType.WEB_USER
            ? "Individual Web User"
            : "IP Authentication"
          : "(Not Logged In)",
      [MetadataKeys.USER_OR_IP_RANGE_SALESFORCE_ID]: sessionInfo != null ? sessionInfo.salesforceId : "(Not Logged In)",
      [MetadataKeys.USER_ORGANIZATION_SALESFORCE_ID]: sessionInfo != null ? sessionInfo.accountId : "(Not Logged In)",
      [MetadataKeys.USER_PERMISSIONS]:
        sessionInfo != null
          ? sessionInfo.isVignetteTrial
            ? "vignette-trial"
            : "vignette-subscriber"
          : "(Not Logged In)",

      // Page metadata
      [MetadataKeys.CONTENT_TITLE]: this.pageName.trim() || "Vignette",
      [MetadataKeys.CMS_CONTENT_ID]: undefined,
      [MetadataKeys.SITESECTION_CHANNEL]: "Vignette",
      [MetadataKeys.CMS_TAGS]: undefined,
      [MetadataKeys.PAYWALLED_CONTENT_STATUS]: "Behind the Paywall",
      [MetadataKeys.PAGE_TYPE]: "(Unknown)",
      [MetadataKeys.SITESECTION]: "(Unknown)",
      [MetadataKeys.VIGNETTE_PRIMARY_PROFILE_TYPE]: undefined,
    };
    VignetteHelpers.Analytics.push(this.metadata);
  }

  setAnalyticsMetadata(key: MetadataKeys, value: string): void {
    LogService.info(`ViewAnalytics - updating metadata for key: '${key}'`);
    this.metadata[key] = value;

    VignetteHelpers.Analytics.push({
      [key]: value,
    });
  }

  clearAnalyticsMetadata(key: MetadataKeys): void {
    LogService.info(`ViewAnalytics - clearing metadata for key: '${key}'`);
    this.metadata[key] = undefined;
    VignetteHelpers.Analytics.push({
      [key]: undefined,
    });
  }

  pushPageViewEvent(): void {
    LogService.info(`ViewAnalytics - sending page view event beacon`);
    VignetteHelpers.Analytics.pushEvent("page-view-ready");
  }
}
